import React, { useContext } from 'react';
import { AppContext } from '@prisjakt/ui-app-context';
import ChevronDown from 'mdi-react/ChevronDownIcon';
import Button from '@prisjakt/ui-button';
import { Price } from '../../../../../types';
import * as S from '../styles';

const PriceListFooter: React.FC<IPriceListFooterProps> = props => {
  const {
    showProductInformationTexts,
    sortedPrices,
    showMorePrices,
    numberOfVisiblePrices,
    setShowMorePrices,
  } = props;

  const { t } = useContext(AppContext);

  return (
    <div>
      {showProductInformationTexts &&
        sortedPrices &&
        sortedPrices.length > 0 && (
          <S.Information>
            {t('product', 'price-list.data-information')}
          </S.Information>
        )}
      {!showMorePrices &&
        sortedPrices &&
        sortedPrices.length > numberOfVisiblePrices && (
          <Button
            style={{ width: '100%' }}
            iconPosition="bottom"
            icon={<ChevronDown />}
            variant="text"
            color="link"
            onClick={() => setShowMorePrices(true)}
          >
            {t('product', 'prices.show-more-prices-button')}
          </Button>
        )}
    </div>
  );
};

export default PriceListFooter;

interface IPriceListFooterProps {
  showProductInformationTexts: boolean | undefined;
  sortedPrices: Price[] | null | undefined;
  showMorePrices: boolean;
  numberOfVisiblePrices: number;
  setShowMorePrices: React.Dispatch<React.SetStateAction<boolean>>;
}
